import { CreatorChallenge } from '../../../../types/challenges';
import EnhancedModal from '../../../common/EnhancedModal/EnhancedModal';
import AllChallengesContent from './AllChallengesContent';
import styles from './allChallenges.module.css';

type AllChallengesModalProps = {
  open: boolean;
  onClose: () => void;
  defaultCurrency: string;
  address: any;
  brandName?: string;
  onClaimed?: () => void;
  onClaimReward?: (challenge: CreatorChallenge) => void;
};

export default function AllChallengesModal({
  open,
  onClose,
  defaultCurrency,
  address,
  brandName,
  onClaimed,
  onClaimReward,
}: AllChallengesModalProps) {
  return (
    <EnhancedModal
      open={open}
      onClose={onClose}
      title="All challenges"
      width={960}
      height={680}
      maxWidth="calc(100vw - 48px)"
      maxHeight="calc(100vh - 40px)"
      className={styles.allChallengesModal}
      headerClassName={styles.allChallengesHeader}
      bodyClassName={styles.allChallengesBody}
    >
      <AllChallengesContent
        defaultCurrency={defaultCurrency}
        address={address}
        brandName={brandName}
        onClaimed={onClaimed}
        onClaimReward={onClaimReward}
      />
    </EnhancedModal>
  );
}
